import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
// import "./ReportManagement.css";
import FileExport from "./../../Assets/Images/CommanImages/fileexport.png";
import Filter from "./../../Assets/Images/CommanImages/filter.png";
import columnaddition from "./../../Assets/Images/CommanImages/rectangleplus.png";
import updown from "./../../Assets/Images/CommanImages/updown.png";
import searchicon from "./../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "./../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "./../../Assets/Images/CommanImages/Rarrowbar.png";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
// import "./TableComponent.css";
import "./testsection.css";
import { API_BASE_URL } from "../../Config/Config";

const TableComponent = ({ headers, data, searchPlaceholder, dataClient, setPagePath }) => {
    const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [visibleColumns, setVisibleColumns] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [averageRunTime, setAverageRunTime] = useState("");
    const [filterRunTime, setFilterRunTime] = useState("");

    useEffect(() => {
        setVisibleColumns(headers.slice(0, 5));
    }, [headers]);

    const handleColumnSelection = (column) => {
        if (visibleColumns.includes(column)) {
            setVisibleColumns(visibleColumns.filter((col) => col !== column));
        } else {
            setVisibleColumns([...visibleColumns, column]);
        }
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };

    const handleFilterRunTimeChange = (e) => {
        setFilterRunTime(e.target.value);
    };

    const handleApplyFilter = () => {
        setAverageRunTime(filterRunTime);
        setIsFilterVisible(false); // Close the modal
        setCurrentPage(1); // Reset to the first page on filter
    };

    // const filteredData = data.filter((row) => {
    //     const matchesSearchQuery = row[0]
    //         .toLowerCase()
    //         .includes(searchQuery.toLowerCase());
    //     const matchesAverageRunTime =
    //         averageRunTime === "" || row[2] === averageRunTime;
    //     return matchesSearchQuery && matchesAverageRunTime;
    // });

    // const filteredData = data.filter((row) => {
    //     const matchesSearchQuery = row[0] && String(row[0]).toLowerCase().includes(searchQuery.toLowerCase());
    //     const matchesAverageRunTime = averageRunTime === "" || row[2] === averageRunTime;
    //     return matchesSearchQuery && matchesAverageRunTime;
    // });

    const filteredData = data.filter((row) => {
        const matchesSearchQuery = row.some((cell) =>
            cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
        );
        const matchesAverageRunTime = averageRunTime === "" || row[2] === averageRunTime;
        return matchesSearchQuery && matchesAverageRunTime;
    });


    const handleSort = (column) => {
        let direction = "asc";
        if (sortConfig.key === column && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key: column, direction });
    };

    const sortedData = React.useMemo(() => {
        let sortableData = [...filteredData];
        if (sortConfig.key !== null) {
            const colIndex = headers.indexOf(sortConfig.key);
            sortableData.sort((a, b) => {
                if (a[colIndex] < b[colIndex]) {
                    return sortConfig.direction === "asc" ? -1 : 1;
                }
                if (a[colIndex] > b[colIndex]) {
                    return sortConfig.direction === "asc" ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableData;
    }, [filteredData, sortConfig, headers]);

    const handleExport = (type) => {
        const exportData = sortedData.map((row) =>
            visibleColumns.map((column) => row[headers.indexOf(column)])
        );

        const fileName = prompt("Enter the file name:");

        if (!fileName) {
            return;
        }

        if (type === "excel" || type === "csv") {
            const worksheet = XLSX.utils.aoa_to_sheet([
                visibleColumns,
                ...exportData,
            ]);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

            const fileExtension = type === "csv" ? "csv" : "xlsx";
            const mimeType =
                type === "csv"
                    ? "text/csv"
                    : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

            const file = XLSX.write(workbook, {
                bookType: fileExtension,
                type: "array",
            });
            const blob = new Blob([file], { type: mimeType });
            FileSaver.saveAs(blob, `${fileName}.${fileExtension}`);
        } else if (type === "pdf") {
            const doc = new jsPDF();
            doc.autoTable({
                head: [visibleColumns],
                body: exportData,
            });

            doc.save(`${fileName}.pdf`);
        }
    };

    const handlePageSizeChange = (size) => {
        setPageSize(size);
        setCurrentPage(1); // Reset to the first page
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const totalPages = Math.ceil(sortedData.length / pageSize);
    const paginatedData = React.useMemo(() => {
        const startIndex = (currentPage - 1) * pageSize;
        return sortedData.slice(startIndex, startIndex + pageSize);
    }, [sortedData, currentPage, pageSize]);

    const renderPagination = () => {
        const pages = [];
        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(
                    <button
                        key={i}
                        onClick={() => handlePageChange(i)}
                        style={{ borderRadius: "5px" }}
                        className={i === currentPage ? "active" : ""}
                    >
                        {i}
                    </button>
                );
            }
        } else {
            if (currentPage <= 3) {
                for (let i = 1; i <= 3; i++) {
                    pages.push(
                        <button
                            key={i}
                            style={{ borderRadius: "5px" }}
                            onClick={() => handlePageChange(i)}
                            className={i === currentPage ? "active" : ""}
                        >
                            {i}
                        </button>
                    );
                }
                pages.push(
                    <span style={{ borderRadius: "5px" }} key="dots1">
                        ...
                    </span>
                );
                pages.push(
                    <button
                        key={totalPages}
                        onClick={() => handlePageChange(totalPages)}
                        style={{ borderRadius: "5px" }}
                    >
                        {totalPages}
                    </button>
                );
            } else if (currentPage > 3 && currentPage < totalPages - 2) {
                pages.push(
                    <button
                        key={1}
                        onClick={() => handlePageChange(1)}
                        style={{ borderRadius: "5px" }}
                    >
                        1
                    </button>
                );
                pages.push(
                    <span style={{ borderRadius: "5px" }} key="dots1">
                        ...
                    </span>
                );
                for (let i = currentPage - 1; i <= currentPage + 1; i++) {
                    pages.push(
                        <button
                            key={i}
                            onClick={() => handlePageChange(i)}
                            style={{ borderRadius: "5px" }}
                            className={i === currentPage ? "active" : ""}
                        >
                            {i}
                        </button>
                    );
                }
                pages.push(
                    <span style={{ borderRadius: "5px" }} key="dots2">
                        ...
                    </span>
                );
                pages.push(
                    <button
                        key={totalPages}
                        onClick={() => handlePageChange(totalPages)}
                        style={{ borderRadius: "5px" }}
                    >
                        {totalPages}
                    </button>
                );
            } else {
                pages.push(
                    <button
                        key={1}
                        onClick={() => handlePageChange(1)}
                        style={{ borderRadius: "5px" }}
                    >
                        1
                    </button>
                );
                pages.push(
                    <span style={{ borderRadius: "5px" }} key="dots1">
                        ...
                    </span>
                );
                for (let i = totalPages - 2; i <= totalPages; i++) {
                    pages.push(
                        <button
                            key={i}
                            onClick={() => handlePageChange(i)}
                            style={{ borderRadius: "5px" }}
                            className={i === currentPage ? "active" : ""}
                        >
                            {i}
                        </button>
                    );
                }
            }
        }
        return pages;
    };

    return (
        <div>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "1.5%",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "82vw",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <input
                            type="text"
                            placeholder={searchPlaceholder}
                            name="search"
                            className="input-top-tc"
                            onChange={handleSearch}
                        />
                        <img src={searchicon} className="search-icon-tc" alt="search" />
                    </div>
                    <div style={{ textAlign: "end" }}>
                        Displaying{" "}
                        {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
                        {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
                        {sortedData.length} records |
                        {["10", "25", "50", "100", "500"].map((size) => (
                            <span
                                key={size}
                                onClick={() => handlePageSizeChange(Number(size))}
                                style={{
                                    cursor: "pointer",
                                    margin: "0 5px",
                                    textDecoration:
                                        size === pageSize.toString() ? "none" : "underline",
                                    color: size === pageSize.toString() ? "black" : "#337AB7",
                                }}
                            >
                                {size}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
            <div
                className="row-tc"
                style={{
                    backgroundColor: "#D6D6D6",
                    marginTop: "9px",
                    borderTop: "1px solid grey",
                    borderBottom: "1px solid grey",
                }}
            >
                <div
                    className="col-cs2-tc"
                    style={{
                        backgroundColor: "#FFBD20",
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        paddingLeft: "8px",
                    }}
                // onClick={() => setIsFilterVisible(!isFilterVisible)}
                >
                    <img
                        src={Filter}
                        style={{ height: "25px", width: "25px" }}
                        alt="filter"
                    />
                    <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
                </div>
                <div
                    className="col-tc"
                    style={{
                        textAlign: "end",
                        marginRight: "8px",
                        display: "flex",
                        alignItems: "center",
                        position: "relative",
                        cursor: "pointer",
                    }}
                    onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
                >
                    <img
                        src={columnaddition}
                        style={{ height: "25px", width: "25px" }}
                        alt="column addition"
                    />
                    <span style={{ marginLeft: "10px", color: "#2F2E40" }}>
                        Column Selection
                    </span>
                    {isColumnDivVisible && (
                        <>
                            <div className="arrow-up-tc"></div> {/* Add the arrow */}
                            <div className="popupColumn-tc">
                                {headers.map((column, index) => (
                                    <div
                                        key={index}
                                        onClick={() => handleColumnSelection(column)}
                                    >
                                        <input
                                            type="checkbox"
                                            id={`column-${index}`}
                                            name="columnSelection"
                                            value={column}
                                            className="square-checkbox-tc"
                                            checked={visibleColumns.includes(column)}
                                            readOnly
                                        />
                                        <label
                                            htmlFor={`column-${index}`}
                                        // style={{ marginLeft: "10px" }}
                                        >
                                            {column}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </div>

            <table className="table-tc" style={{ width: "100%" }}>
                <thead>
                    <tr>
                        {visibleColumns.map((heading, index) => (
                            <th
                                className="Heading-tc"
                                key={index}
                                style={{ textAlign: "center", cursor: "pointer" }}
                            >
                                <span
                                    style={{
                                        display: "flex",
                                        alignItems: "left",
                                        justifyContent: "left",
                                    }}
                                >
                                    {heading}
                                    <img
                                        onClick={() => handleSort(heading)}
                                        src={updown}
                                        style={{
                                            height: "20px",
                                            width: "20px",
                                            marginLeft: "5px",
                                        }}
                                        alt="sort"
                                    />
                                </span>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {paginatedData.map((row, rowIndex) => (
                        <tr
                            key={rowIndex}
                            className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
                        >
                            {visibleColumns.map((column, cellIndex) => (
                                <td
                                    key={cellIndex}
                                    style={{ textAlign: "left", color: "#6A6A6A" }}
                                >
                                    {headers.indexOf(column) === 0 ? (
                                        <div
                                            style={{ color: "#6A6A6A" }}
                                            // to={{
                                            //   pathname: row[4],
                                            //   // state: { dataClient: dataClient },
                                            // }}
                                            // to={`${row[4]}?reportName=${encodeURIComponent(row[headers.indexOf(column)])}`}
                                            // onClick={() => {
                                            //     // console.log('Navigating to:', row[4], 'with displayName:', row[headers.indexOf(column)]);
                                            //     setPagePath(`Reports > Reports Dashboard > ${row[headers.indexOf(column)]}`)
                                            // }}
                                        >
                                            {row[headers.indexOf(column)]}

                                        </div>
                                    ) : (
                                        row[headers.indexOf(column)]
                                    )}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="pagination-tc">
                <button
                    onClick={() => handlePageChange(1)}
                    disabled={currentPage === 1}
                    className="extreme-left-tc-pagination"
                >
                    <img src={leftArrow} alt="" />
                </button>
                <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="lefttc-pagination"
                >
                    {"<"}
                </button>
                {renderPagination()}
                <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="righttc-pagination"
                >
                    {">"}
                </button>
                <button
                    onClick={() => handlePageChange(totalPages)}
                    disabled={currentPage === totalPages}
                    className="extreme-right-tc-pagination"
                >
                    <img src={rightArrow} alt="" />
                </button>
            </div>

            {isFilterVisible && (
                <div className="filter-sidebar-tc">
                    <div className="filter-content-tc" style={{ position: "relative" }}>
                        <button
                            className="repman-cross-btn"
                            style={{
                                position: "absolute",
                                left: "-29px",
                                height: "40px",
                                width: "30px",
                                color: "white",
                                border: "none",
                                fontSize: "20px",
                                fontWeight: "700",
                                borderRadius: "5px 0px 0px 5px",
                            }}
                            onClick={() => {
                                setIsFilterVisible(false);
                            }}
                        >
                            <p>X</p>
                        </button>
                        <h3 className="AdvanceF-heading-tc"> Filter</h3>
                        <div style={{ display: "flex", justifyContent: "end" }}>
                            <button
                                style={{
                                    width: "30%",
                                    height: "32px",
                                    borderRadius: "5px",
                                    border: "2px solid #2F2E40",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    backgroundColor: "white",
                                    marginRight: "8px",
                                    marginTop: "10px",
                                }}
                                onClick={handleApplyFilter}
                            >
                                APPLY
                            </button>
                        </div>
                        <input
                            type="text"
                            placeholder="Enter Average Run Time"
                            value={filterRunTime}
                            onChange={handleFilterRunTimeChange}
                        />
                    </div>
                </div>
            )}

            {isModalVisible && (
                <div className="modal-tc">
                    <div className="modal-content-tc">
                        <h3>Select Export File Type</h3>
                        <button
                            onClick={() => [handleExport("excel"), setIsModalVisible(false)]}
                        >
                            Excel
                        </button>
                        <button
                            onClick={() => [handleExport("csv"), setIsModalVisible(false)]}
                        >
                            CSV
                        </button>
                        <button
                            onClick={() => [handleExport("pdf"), setIsModalVisible(false)]}
                        >
                            PDF
                        </button>
                        <button onClick={() => setIsModalVisible(false)}>Cancel</button>
                    </div>
                </div>
            )}
        </div>
    );
};

const TestSectionManagement = ({
    setMessageBox,
    setIsMessageBoxVisible,
    setActiveImg,
    dataClient,
    setPagePath
}) => {
    //   const headers = ["Report Title", "Description", "Average Run Time"];
    const headers = [
        "Test Section ID",
        "Test Section Name",
        "Test Section Description",
        "Test Section Instructions",
        "Correct Question Level Marks",
        "Correct Question Level Order",
        "Correct Option Level Marks",
        "Correct Option Level Order",
        "Wrong Question Level Marks",
        "Wrong Question Level Order",
        "Wrong Option Level Marks",
        "Wrong Option Level Order",
        "Created By",
        "Create Date",
        "Last Updated By",
        "Last Updated On"
    ];

    const [reportDashboardData, setReportDashboardData] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        fetch(
            `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-test-sections`)
            .then((response) => response.json())
            .then((data) => {
                const transformedData = data.data.map((report) => [
                    report.test_section_id,
                    report.test_section_name,
                    report.test_section_desc,
                    report.test_section_instructions,
                    report.correct_ques_level_marks,
                    report.correct_ques_level_order,
                    report.correct_option_level_marks,
                    report.correct_option_level_order,
                    report.wrong_ques_level_marks,
                    report.wrong_ques_level_order,
                    report.wrong_option_level_marks,
                    report.wrong_option_level_order,
                    report.created_by,
                    report.create_date,
                    report.last_updated_by,
                    report.last_updated_on,
                ]);
                setReportDashboardData(transformedData);
            })
            .catch((error) =>
                console.error("Error fetching report_dashboard:", error)
            );
    }, []);

    // console.log(reportDashboardData, "test section data");

    return (
        <div
            style={{
                height: "auto",
                width: "100%",
                paddingLeft: "20px",
                marginBottom: "40px",
            }}
        >
            <div
                className=""
                style={{ position: "sticky", top: "0", paddingLeft: "15px" }}
            >
                <div className="Header-up ">
                    <p style={{ color: "#2F2E40", fontSize: "30px" }}>
                        Test Section Management
                    </p>
                    <button className="create-test-section-btn" onClick={() => navigate("/test_section")}>
                        <span className="plus-icon-create">+</span>CREATE
                    </button>
                </div>
                <p style={{ marginTop: "1%", color: "#2F2E40" }}>
                    View, create, or filter test section. View and manage the list of test sections
                    already available or create a new test sections.
                </p>

                <div>
                    <TableComponent
                        headers={headers}
                        data={reportDashboardData}
                        searchPlaceholder="Search by Test Section..."
                        dataClient={dataClient}
                        setPagePath={setPagePath}
                    />
                </div>
            </div>
        </div>
    );
};

export default TestSectionManagement;
